import { Coordinate } from 'ol/coordinate';
import { BuoyMappedForDrawing } from '../buoy';
import { GridLineDrawingPropertyDto } from 'models/mooring';

type GridLineOutput = {
  Id: number;
  MooringNo: string;
  AnalysisNo: string;
  IsAccident: boolean;
  Start: Coordinate;
  End: Coordinate;
};

export function calculateLineConnections(grid: BuoyMappedForDrawing[][], lines: GridLineDrawingPropertyDto[]) {
  if (!grid.length || !grid[0].length) {
    return [];
  }

  const rows = grid.length;
  const cols = grid[0].length;

  const result: GridLineOutput[] = [];

  if (!grid || grid.length === 0 || grid[0].length === 0) {
    return result;
  }
  // Horizontal lines
  for (let row = 0; row < rows; row++) {
    for (let col = 0; col < cols - 1; col++) {
      const buoy1 = grid[row][col];
      const buoy2 = grid[row][col + 1];

      const line = lines.find((l) => {
        return (l.FromBuoyId === buoy1.Id && l.ToBuoyId === buoy2.Id) || (l.FromBuoyId === buoy2.Id && l.ToBuoyId === buoy1.Id);
      });

      if (!line) {
        continue;
      }

      result.push({
        Id: line.Id,
        AnalysisNo: line.AnalysisNo,
        MooringNo: line.MooringNo,
        IsAccident: line.IsAccident,
        Start: buoy1.Center,
        End: buoy2.Center,
      });
    }
  }

  // Vertical lines
  for (let row = 0; row < rows - 1; row++) {
    for (let col = 0; col < cols; col++) {
      const buoy1 = grid[row][col];
      const buoy2 = grid[row + 1][col];

      const line = lines.find((l) => {
        return (l.FromBuoyId === buoy1.Id && l.ToBuoyId === buoy2.Id) || (l.FromBuoyId === buoy2.Id && l.ToBuoyId === buoy1.Id);
      });

      if (!line) {
        continue;
      }

      result.push({
        Id: line.Id,
        AnalysisNo: line.AnalysisNo,
        MooringNo: line.MooringNo,
        IsAccident: line.IsAccident,
        Start: buoy1.Center,
        End: buoy2.Center,
      });
    }
  }

  return result;
}
